var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoOnSite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.55,16.72l-13.86,11.76v15.97h27.73v-15.97l-13.87-11.76Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.08,19.29c.28-.1,.55-.25,.78-.47,.24-.24,.4-.54,.49-.85,.08-.22,.13-.45,.13-.69V6.63c0-1.11-.9-2-2-2s-2,.89-2,2v5.98L8,4.12c-.78-.78-2.05-.78-2.83,0s-.78,2.05,0,2.83L13.66,15.44H7.68c-1.1,0-2,.89-2,2s.9,2,2,2h10.65c.27,0,.52-.05,.76-.15Z",
    fill: filledColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.69,30.33v10.12h7.09c.11,0,.22,0,.33,.01h4.89c.11,0,.22-.01,.33-.01h7.09v-10.12l-9.87-8.37-9.86,8.37Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.55,16.72l-13.86,11.76v15.97h27.73v-15.97l-13.87-11.76Zm9.87,23.73h-7.09c-.11,0-.22,0-.33,.01h-4.89c-.11,0-.22-.01-.33-.01h-7.09v-10.12l9.86-8.37,9.87,8.37v10.12Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.08,19.29c.28-.1,.55-.25,.78-.47,.24-.24,.4-.54,.49-.85,.08-.22,.13-.45,.13-.69V6.63c0-1.11-.9-2-2-2s-2,.89-2,2v5.98L8,4.12c-.78-.78-2.05-.78-2.83,0s-.78,2.05,0,2.83L13.66,15.44H7.68c-1.1,0-2,.89-2,2s.9,2,2,2h10.65c.27,0,.52-.05,.76-.15Z",
    fill: outlineColor
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOnSite);
export default __webpack_public_path__ + "static/media/ico-on-site.e9e4acaa9380c359a2d8597553c4f473.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;